import styled from "styled-components";
import { BodyDefault, BodySmall, HeadLine1, HeadLine3, VerySmall } from "../../../components/typography/styled";

export const Container = styled.div`
  display: inline-flex;
  box-sizing: border-box;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px 30px 50px 30px;
  width: 100%;
  justify-content: space-between;
  position: relative;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    min-width: 0;
    padding: 10px 16px 40px;
  }
`

export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  margin-top: 20px;
`
export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items:flex-start;
  /* width: 360px; */
  margin-top: 20px;

  @media screen and (max-width: 768px) {
    width: 100%;
    min-width: 0;
  }
`

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction:column;
  min-width: 0;

  @media screen and (max-width: 768px) {
    width: 100%;
  }

`

export const SourceTypeWrapper = styled.div`
  width: 500px;
  max-width: 100%;
  min-width: 0;
`

export const EstimateContainer = styled.div`
  /* display: flex; */
  flex-direction: column;
  box-sizing: border-box;
  padding: 15px;
  /* max-width: 240px; */
  width: 240px;
  /* height: 320px; */
  background: ${({theme}) => theme.palette[200]};
  border-radius: 8px;
  margin-top: 20px;

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    margin-top: 0;
  }
`

export const EstimateTitle = styled(HeadLine3)`
  color:${({theme}) => theme.palette[850]};
`
export const EstimateSum = styled(BodyDefault)`
  color:${({theme}) => theme.palette[850]};
`
export const PerHour = styled(VerySmall)`
  color:${({theme}) => theme.palette[650]};
  margin-left:2px;
  margin-bottom:2px;
`
